import styled from 'styled-components';

import { media } from '@theme/media';

export const Container = styled.div<{ isVisible: boolean }>`
  margin: 100px 0;
  position: relative;
  width: 100%;
  text-align: center;
  padding: 0 10px 10px;
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

  ${media.tablet} {
    padding: 0 30px 80px;
  }
`;
